import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { ActionFailed, Toaster } from '@tokeet/tv3-platform'
import { RoomsService } from './rooms.service'
import {
  DeleteRoom,
  DeleteRoomComplete,
  GetRooms,
  GetRoomsComplete,
  UpdateRoom,
  UpdateRoomComplete,
  UpsertRooms,
  UpsertRoomsComplete,
} from './rooms.actions'
import { catchError, map, switchMap, tap } from 'rxjs/operators'
import { of } from 'rxjs'

@Injectable()
export class RoomsEffects {
  @Effect()
  getRooms$ = this.actions$.pipe(
    ofType(GetRooms),
    switchMap(({ rentalId }) =>
      this.roomsService.getRentalRooms(rentalId).pipe(
        map((rooms) => GetRoomsComplete({ rooms })),
        catchError((error) => of(new ActionFailed(error)))
      )
    )
  )

  @Effect()
  upsertRooms$ = this.actions$.pipe(
    ofType(UpsertRooms),
    switchMap(({ createRooms, updateRooms }) =>
      this.roomsService.upsertRooms(createRooms, updateRooms).pipe(
        tap(() => this.toaster.success($localize`Rooms updated successfully`)),
        map((response) => UpsertRoomsComplete({ rooms: response })),
        catchError((error) => of(new ActionFailed(error)))
      )
    )
  )

  @Effect()
  updateRoom$ = this.actions$.pipe(
    ofType(UpdateRoom),
    switchMap(({ room, silent }) =>
      this.roomsService.updateRoom(room).pipe(
        tap(() => {
          if (!silent) {
            this.toaster.success($localize`Room updated successfully`)
          }
        }),
        map((response) => UpdateRoomComplete({ update: { id: response.pkey, changes: response } })),
        catchError((error) => of(new ActionFailed(error)))
      )
    )
  )

  @Effect()
  deleteRoom$ = this.actions$.pipe(
    ofType(DeleteRoom),
    switchMap(({ room }) =>
      this.roomsService.deleteRoom(room).pipe(
        tap(() => this.toaster.success($localize`Room deleted successfully`)),
        map(() => DeleteRoomComplete({ room })),
        catchError((error) => of(new ActionFailed(error)))
      )
    )
  )

  constructor(private actions$: Actions, private roomsService: RoomsService, private toaster: Toaster) {}
}
